import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  header: {
    color: theme.palette.textcolor.main,
    textTransform: 'uppercase',
    fontSize: '1.4375em',
    fontStyle: 'italic',
    marginBottom: 10,
  },
  text: {
    color: '#000000',
    display: 'block',
    maxWidth: 700,
  },
  KpiWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexWrap: 'wrap',
    columnGap: '1.5em',
  },
  kpi: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',
    '@media (max-width: 610px)': {
      width: '40%',
    },
  },
  kpiNumber: {
    color: theme.palette.primary.main,
    fontSize: '4.8125em',
    fontWeight: 900,
    fontFamily: 'Playfair Display, serif',
    [theme.breakpoints.down('sm')]: {
      fontSize: '4rem',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '3rem',
    },
  },
  kpiText: {
    fontSize: '1.4375em',
    fontFamily: 'Source Sans Pro, sans-serif',
    fontWeight: 600,
    color: theme.palette.textcolor.main,
    fontStyle: 'italic',
    lineHeight: 1,
    textAlign: 'center',
    maxWidth: 110,
  },
  percentSign: {
    fontSize: '0.9em',
    color: 'pink',
  },
}));

export default useStyles;
